import React, { useEffect, useState } from 'react'
import { MapContainer, Marker, Popup, TileLayer, GeoJSON } from 'react-leaflet'
import L from 'leaflet'
import "leaflet/dist/leaflet.css";
import { ElectionIncidence } from "../lib/types";
import Alert from "../../../assets/img/IncidentIcon.jpeg"
import FlashIcon from "../../../assets/img/FashIcon.jpeg"
import { IncidenceDetails } from "./IncidenceDetails";
import geoData from "../lib/flashpoint.json"

const center: any = [7.9465, 1.0232]

type Props = {
    incidences: ElectionIncidence[]
}

function Map({ incidences }: Props) {
    const [map, setMap] = useState<any>()
    const [isDrawerOpen, setDrawerOpen] = useState(false)
    const [selectedIncidence, setSelectedIncidence] = useState<ElectionIncidence | null>(null)
    const [geojsonData, setGeojsonData] = useState<any>(null); // For GeoJSON data

    useEffect(() => {
        if (map) map.invalidateSize()
    }, [map])

    useEffect(() => {
        setGeojsonData(geoData)
    }, [incidences]);

    const mySvgIcon = new L.Icon({
        iconUrl: Alert,
        iconSize: [25, 25]
    })
    const flashIcon = new L.Icon({
        iconUrl: FlashIcon,
        iconSize: [25, 25]
    })

    return (
        <div className="w-full h-full">
            <MapContainer
                ref={setMap}
                style={{ width: '100%', height: '100%' }}
                center={center}
                zoom={8}
                scrollWheelZoom={true}
            >
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                {incidences &&
                    incidences.map((incidence: ElectionIncidence) =>
                        <Marker
                            key={`${incidence.gps.latitude}${incidence.gps.longitude}`}
                            icon={mySvgIcon}
                            position={[incidence.gps.latitude, incidence.gps.longitude]} // Corrected to use longitude
                            eventHandlers={{
                                click: () => {
                                    setDrawerOpen(true)
                                    setSelectedIncidence(incidence)
                                }
                            }}
                        >
                            <Popup>{incidence.constituency}</Popup>
                        </Marker>
                    )}

                {/* Render GeoJSON Layer */}
                {geojsonData && (
                    <GeoJSON
                        data={geojsonData}
                        pointToLayer={(feature, latlng) =>
                            L.marker(latlng, { icon: flashIcon }) // Add a custom icon for point features
                        }
                        onEachFeature={(feature, layer) => {
                            const regionName = feature.properties?.region || "No Region";
                            const flashpoints = feature.properties?.no_of_flashpoints || "N/A";
                            const popupContent = `<strong>Region:</strong> ${regionName}<br/><strong>Flashpoints:</strong> ${flashpoints}`;

                            layer.bindPopup(popupContent);
                        }}
                        style={() => ({
                            color: "blue",
                            weight: 2,
                            fillOpacity: 0.3,
                        })}
                    />
                )}

            </MapContainer>
            {selectedIncidence && <IncidenceDetails onClose={() => setDrawerOpen(false)} open={isDrawerOpen} incidence={selectedIncidence} />}
        </div>
    )
}

export default Map;
